import { styled } from "@mui/material/styles";
import { ListItem } from "@mui/material";

export const StyledListItem = styled(ListItem)({
  borderBottom: "solid 1px #eee",
  paddingLeft: "2px",
});
